import React, { forwardRef, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, Slide, SlideProps } from '@gmm/ui';
import { useFullscreenContext } from '../context';
import { FullscreenHeading } from './heading';
import { FullscreenProblemFetcher } from './fullscreenProblemFetcher';

const Transition = forwardRef(function Transition(
  props: SlideProps,
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const FullscreenPreview: FC = () => {
  const {
    currentType,
    description,
    isModalOpen,
    showNextSibling,
    showPreviousSibling,
    title,
    studentInTestId,
    examRestoreId,
    studentInClassId,
    problemTabText,
    helpRequestedProblemData,
    lockedExamProblemParams,
    isSkillDiscoveryLockedExamProblem,
  } = useFullscreenContext();

  const [t] = useTranslation(['problemPreview']);

  // Determine problem type upfront
  const requestingHelpProblem = !!helpRequestedProblemData;
  const examRelated = !!studentInTestId;
  const currentProblem = !requestingHelpProblem && !!studentInClassId;

  const problemType = isSkillDiscoveryLockedExamProblem
    ? 'skillDiscoveryLockedExamProblem'
    : lockedExamProblemParams
    ? 'lockedExamTemplate'
    : currentProblem
    ? 'current'
    : examRelated
    ? 'exam'
    : requestingHelpProblem
    ? 'helpRequested'
    : 'sample';

  const showRefresh = problemType === 'sample';
  const tabText =
    problemTabText ||
    (problemType === 'sample'
      ? t('problemPreview:problemTab.sample')
      : t('problemPreview:problemTab.current'));

  return (
    <Dialog fullScreen open={isModalOpen} TransitionComponent={Transition}>
      <FullscreenHeading
        description={description}
        showNextSibling={showNextSibling}
        showPreviousSibling={showPreviousSibling}
        title={title}
      />
      <FullscreenProblemFetcher
        problemType={problemType}
        studentInClassId={studentInClassId}
        studentInTestId={studentInTestId}
        examRestoreId={examRestoreId}
        currentType={currentType}
        helpRequestedProblemData={helpRequestedProblemData}
        lockedExamProblemParams={lockedExamProblemParams}
        elevation={0}
        isPreviewModal
        showRefresh={showRefresh}
        title={title}
        problemTabText={tabText}
      />
    </Dialog>
  );
};
